(() => {
  let headerObserver;
  function updateMaisonHeader() {
    const header = document.querySelector('[data-maison-transparent="true"]');
    const firstSection = document.querySelector('#MainContent > .shopify-section');
    const enabled = Boolean(header && firstSection?.querySelector('.maison-hero'));
    document.body.classList.toggle('maison-transparent', enabled);
    headerObserver?.disconnect();
    if (!enabled) return;
    const measure = () => document.documentElement.style.setProperty('--maison-header-height', `${header.offsetHeight}px`);
    measure();
    headerObserver = new ResizeObserver(measure);
    headerObserver.observe(header);
  }
  function updateMaisonScroll() {
    document.body.classList.toggle('maison-scrolled', window.scrollY > 24);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateMaisonHeader, { once: true });
  else updateMaisonHeader();
  updateMaisonScroll();
  window.addEventListener('scroll', updateMaisonScroll, { passive: true });
  document.addEventListener('shopify:section:load', updateMaisonHeader);
  document.addEventListener('shopify:section:unload', updateMaisonHeader);
  document.addEventListener('shopify:section:reorder', updateMaisonHeader);
})();
